// Redux
import { AsyncResult, Action, ApiAction } from '../../index';
import api from '../../redux-api';

// Types
import { TaxesState } from '../types/taxe-rates';

// Initial State
const INITIAL_STATE: TaxesState = {
  taxRates: null,
};

// Actions
const LOAD_TAXES: ApiAction = {
  type: 'connect/taxes',
  endpoint: 'taxes',
};

// Reducer
export default function reducer(state: TaxesState = INITIAL_STATE, action: Action): TaxesState {
  switch (action.type) {
    case `${LOAD_TAXES.type}_SUCCESS`: {
      return {
        ...state,
        taxRates: action.data.data,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export const loadTaxes = (): AsyncResult<void> => () => api.get(LOAD_TAXES).then((res: { data: any }) => res.data);
